import { useEffect } from 'react';

import { connect } from 'react-redux';

import { ACTIVATE_RLS_DASHBOARD } from './Dashboard.actions';
import styles from './Dashboard.module.css';
import * as selectors from './dashboardSelectors';
import OngoingLoanView from './ongoingLoanView/OngoingLoanView';
import { useTrackPageView } from '../../../tracking/pageView';
import ApplyFlexiLoanInfoView from '../../applyFlexiLoanView/ApplyFlexiLoanInfoView/ApplyFlexiLoanInfoView';
import { SpillBanner } from '../../spill/SpillBanner';

const mapStateToProps = (state) => ({
    status: state.RLSDashboard.status
});

const mapDispatchToProps = (dispatch) => ({
    activate: () => dispatch({ type: ACTIVATE_RLS_DASHBOARD })
});

const Dashboard = ({ status, activate }) => {
    useTrackPageView({ name: 'RLS Dashboard' });

    useEffect(() => {
        activate();
    }, [activate]);

    return (
        <div className={styles.Dashboard}>
            {(() => {
                switch (status) {
                    case selectors.ONGOING_STATUS:
                        return (
                            <>
                                <div className={styles.bannerContainer}>
                                    <SpillBanner />
                                </div>
                                <OngoingLoanView />
                            </>
                        );
                    default:
                        return <ApplyFlexiLoanInfoView />;
                }
            })()}
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
